/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OtherProfessionalBackground } from './';
import {
    OtherProfessionalBackgroundFromJSON,
    OtherProfessionalBackgroundFromJSONTyped,
    OtherProfessionalBackgroundToJSON,
} from './';
import type { RatedSkill } from './';
import {
    RatedSkillFromJSON,
    RatedSkillFromJSONTyped,
    RatedSkillToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProfileQualificationRequest
 */
export interface ProfileQualificationRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    comatchLegacyNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    commentOnAvailability: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    commentOnDailyRate: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    commentOnFunctionalExpertise: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    commentOnIndustryExpertise: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    commentOnMobility: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    commentOnOtherExpertise: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    engagementComment: string;
    /**
     * 
     * @type {Array<RatedSkill>}
     * @memberof ProfileQualificationRequest
     */
    functionalSkillRatings: Array<RatedSkill>;
    /**
     * 
     * @type {Array<RatedSkill>}
     * @memberof ProfileQualificationRequest
     */
    industrySkillRatings: Array<RatedSkill>;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileQualificationRequest
     */
    interestInInterim: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProfileQualificationRequest
     */
    internalSeniorityLevel?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    limitations: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileQualificationRequest
     */
    noLongerAvailableDueToPermanentEmployment: boolean;
    /**
     * 
     * @type {Array<RatedSkill>}
     * @memberof ProfileQualificationRequest
     */
    otherSkillRatings: Array<RatedSkill>;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    professionalInterests: string;
    /**
     * 
     * @type {Array<OtherProfessionalBackground>}
     * @memberof ProfileQualificationRequest
     */
    selectedOtherProfessionalBackgrounds: Array<OtherProfessionalBackground>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileQualificationRequest
     */
    selectedProfessionalBackgrounds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    softSkills: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationRequest
     */
    relatedSourcingProjectId?: string;
}

/**
 * Check if a given object implements the ProfileQualificationRequest interface.
 */
export function instanceOfProfileQualificationRequest(value: object): value is ProfileQualificationRequest {
    if (!('commentOnAvailability' in value) || value['commentOnAvailability'] === undefined) return false;
    if (!('commentOnDailyRate' in value) || value['commentOnDailyRate'] === undefined) return false;
    if (!('commentOnFunctionalExpertise' in value) || value['commentOnFunctionalExpertise'] === undefined) return false;
    if (!('commentOnIndustryExpertise' in value) || value['commentOnIndustryExpertise'] === undefined) return false;
    if (!('commentOnMobility' in value) || value['commentOnMobility'] === undefined) return false;
    if (!('commentOnOtherExpertise' in value) || value['commentOnOtherExpertise'] === undefined) return false;
    if (!('engagementComment' in value) || value['engagementComment'] === undefined) return false;
    if (!('functionalSkillRatings' in value) || value['functionalSkillRatings'] === undefined) return false;
    if (!('industrySkillRatings' in value) || value['industrySkillRatings'] === undefined) return false;
    if (!('interestInInterim' in value) || value['interestInInterim'] === undefined) return false;
    if (!('limitations' in value) || value['limitations'] === undefined) return false;
    if (!('noLongerAvailableDueToPermanentEmployment' in value) || value['noLongerAvailableDueToPermanentEmployment'] === undefined) return false;
    if (!('otherSkillRatings' in value) || value['otherSkillRatings'] === undefined) return false;
    if (!('professionalInterests' in value) || value['professionalInterests'] === undefined) return false;
    if (!('selectedOtherProfessionalBackgrounds' in value) || value['selectedOtherProfessionalBackgrounds'] === undefined) return false;
    if (!('selectedProfessionalBackgrounds' in value) || value['selectedProfessionalBackgrounds'] === undefined) return false;
    if (!('softSkills' in value) || value['softSkills'] === undefined) return false;
    return true;
}

export function ProfileQualificationRequestFromJSON(json: any): ProfileQualificationRequest {
    return ProfileQualificationRequestFromJSONTyped(json, false);
}

export function ProfileQualificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileQualificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comatchLegacyNotes': json['comatchLegacyNotes'] == null ? undefined : json['comatchLegacyNotes'],
        'commentOnAvailability': json['commentOnAvailability'],
        'commentOnDailyRate': json['commentOnDailyRate'],
        'commentOnFunctionalExpertise': json['commentOnFunctionalExpertise'],
        'commentOnIndustryExpertise': json['commentOnIndustryExpertise'],
        'commentOnMobility': json['commentOnMobility'],
        'commentOnOtherExpertise': json['commentOnOtherExpertise'],
        'engagementComment': json['engagementComment'],
        'functionalSkillRatings': ((json['functionalSkillRatings'] as Array<any>).map(RatedSkillFromJSON)),
        'industrySkillRatings': ((json['industrySkillRatings'] as Array<any>).map(RatedSkillFromJSON)),
        'interestInInterim': json['interestInInterim'],
        'internalSeniorityLevel': json['internalSeniorityLevel'] == null ? undefined : json['internalSeniorityLevel'],
        'limitations': json['limitations'],
        'noLongerAvailableDueToPermanentEmployment': json['noLongerAvailableDueToPermanentEmployment'],
        'otherSkillRatings': ((json['otherSkillRatings'] as Array<any>).map(RatedSkillFromJSON)),
        'professionalInterests': json['professionalInterests'],
        'selectedOtherProfessionalBackgrounds': ((json['selectedOtherProfessionalBackgrounds'] as Array<any>).map(OtherProfessionalBackgroundFromJSON)),
        'selectedProfessionalBackgrounds': json['selectedProfessionalBackgrounds'],
        'softSkills': json['softSkills'],
        'relatedSourcingProjectId': json['relatedSourcingProjectId'] == null ? undefined : json['relatedSourcingProjectId'],
    };
}

export function ProfileQualificationRequestToJSON(value?: ProfileQualificationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comatchLegacyNotes': value['comatchLegacyNotes'],
        'commentOnAvailability': value['commentOnAvailability'],
        'commentOnDailyRate': value['commentOnDailyRate'],
        'commentOnFunctionalExpertise': value['commentOnFunctionalExpertise'],
        'commentOnIndustryExpertise': value['commentOnIndustryExpertise'],
        'commentOnMobility': value['commentOnMobility'],
        'commentOnOtherExpertise': value['commentOnOtherExpertise'],
        'engagementComment': value['engagementComment'],
        'functionalSkillRatings': ((value['functionalSkillRatings'] as Array<any>).map((v) => RatedSkillToJSON(v))),
        'industrySkillRatings': ((value['industrySkillRatings'] as Array<any>).map((v) => RatedSkillToJSON(v))),
        'interestInInterim': value['interestInInterim'],
        'internalSeniorityLevel': value['internalSeniorityLevel'],
        'limitations': value['limitations'],
        'noLongerAvailableDueToPermanentEmployment': value['noLongerAvailableDueToPermanentEmployment'],
        'otherSkillRatings': ((value['otherSkillRatings'] as Array<any>).map((v) => RatedSkillToJSON(v))),
        'professionalInterests': value['professionalInterests'],
        'selectedOtherProfessionalBackgrounds': ((value['selectedOtherProfessionalBackgrounds'] as Array<any>).map((v) => OtherProfessionalBackgroundToJSON(v))),
        'selectedProfessionalBackgrounds': value['selectedProfessionalBackgrounds'],
        'softSkills': value['softSkills'],
        'relatedSourcingProjectId': value['relatedSourcingProjectId'],
    };
}

